export const commonEnv = {
 
  STS_AUTHORITY: 'https://app-ppu-identity-server-dev-canadacentral.azurewebsites.net/',
  CLIENT_ID: 'PPU.Web.Portal.Pulse',
  CLIENT_ROOT: 'http://localhost:4400/',
  CLIENT_SCOPE: 'PPU.Identity.Api PPU.Administration.Api openid profile offline_access role',
  API_ROOT: 'https://app-ppu-admin-api-dev-canadacentral.azurewebsites.net/',
  STRIPE_KEY: 'stripe-key',
  BLOB_STORAGE_URL: 'https://ppu2devstorageaccount.blob.core.windows.net'
};
